/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ProfileEditCompanyDetails_user = {
    readonly id: string;
    readonly logoimageurl: string;
    readonly name: string;
    readonly address: string;
    readonly vatno: string;
    readonly countrycode: string;
    readonly autoaimarkers: boolean;
    readonly " $refType": "ProfileEditCompanyDetails_user";
};
export type ProfileEditCompanyDetails_user$data = ProfileEditCompanyDetails_user;
export type ProfileEditCompanyDetails_user$key = {
    readonly " $data"?: ProfileEditCompanyDetails_user$data;
    readonly " $fragmentRefs": FragmentRefs<"ProfileEditCompanyDetails_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProfileEditCompanyDetails_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "logoimageurl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "address",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vatno",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "countrycode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "autoaimarkers",
      "storageKey": null
    }
  ],
  "type": "Company",
  "abstractKey": null
};
(node as any).hash = 'b23204a1d88aea7da2649cef423ad995';
export default node;
